import React, { useEffect, useRef, useState } from 'react'
import TaskCard from './TaskCard/TaskCard'
import styles from './TasksBoard.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import SearchBooks from '../../Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import asideModalStore from 'Stores/asideModalStore'
import Synchronize from '../../ContentBox/Global/GlobalModalSingle/templates/CRM/Synchronize/Synchronize'
import CardAppearance from '../../ContentBox/Global/GlobalModalSingle/templates/CRM/CardAppearance/CardAppearance'
import AddNewTask from '../../ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewTask/AddNewTask'
import ManagingTaskTypes from '../../ContentBox/Global/GlobalModalSingle/templates/CRM/ManagingTaskTypes/ManagingTaskTypes'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import CustomScrollbar from '../UI/components/CustomScrollbar/CustomScrollbar'

const dateToday = new Date()
const dateYesterday = new Date()
dateYesterday.setDate(dateToday.getDate() - 1)

// Форматируем дату в YYYY-MM-DD по локальному времени (без UTC-сдвига)
const formatDateLocal = (date) => {
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

// Функция для получения новой даты finish_task в зависимости от колонки
const getNewFinishDateByColumnType = (columnType) => {
  const now = new Date()
  const resultDate = new Date()

  switch (columnType) {
    case 'overdue':
      resultDate.setDate(now.getDate() - 1)
      resultDate.setHours(23, 59, 59, 999)
      break
    case 'today':
      resultDate.setHours(23, 59, 59, 999)
      break
    case 'tomorrow':
      resultDate.setDate(now.getDate() + 1)
      resultDate.setHours(23, 59, 59, 999)
      break
    case 'this_week': {
      const dayOfWeek = now.getDay()
      const daysUntilFriday = dayOfWeek <= 5 ? 5 - dayOfWeek : 12 - dayOfWeek
      resultDate.setDate(now.getDate() + daysUntilFriday)
      resultDate.setHours(23, 59, 59, 999)
      break
    }
    case 'next_week': {
      const dayOfWeek = now.getDay()
      const daysUntilNextMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek
      resultDate.setDate(now.getDate() + daysUntilNextMonday)
      resultDate.setHours(23, 59, 59, 999)
      break
    }
    case 'month_plus': {
      resultDate.setMonth(now.getMonth() + 1)
      resultDate.setDate(1)
      resultDate.setHours(23, 59, 59, 999)
      break
    }
    default:
      return null
  }

  return resultDate.toISOString()
}

const TASK_COLUMNS = [
  { id: 1, name: 'Просроченные задачи', type: 'overdue' },
  { id: 2, name: 'Задачи на сегодня', type: 'today' },
  { id: 3, name: 'Задачи на завтра', type: 'tomorrow' },
  { id: 4, name: 'Задачи на эту неделю', type: 'this_week' },
  { id: 5, name: 'Задачи на следующую неделю', type: 'next_week' },
  { id: 6, name: 'Задачи на месяц+', type: 'month_plus' },
]

const TasksBoard = () => {
  const [tasks, setTasks] = useState([])
  const [byType, setByType] = useState([])
  const [byDate, setByDate] = useState([])
  const [employees, setEmployees] = useState([])

  const [filteredTasks, setFilteredTasks] = useState([])
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [checked, setChecked] = useState(false)
  const history = useHistory()

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',

      date: 'Date',
      text: 'Text',
      language: 'Language',
      partition: 'Partition',
      subpartition: 'Subpartition',
      page: 'page',
      englishText: 'English Text',
      english: 'English',
      kazakhAndRussian: 'Kazakh / Russian text',
      russian: 'Russian',
      kazakh: 'Kazakh',
      of: 'of',
      name: 'Name',

      page_title: 'Tasks',
      export_type: 'Export',
      manage_task_types: 'Managing task types',
      synchronize: 'Synchronize',
      auto_update: 'Auto update',
      add_task: 'Add a task',
      cards: 'Cards',
      performer: 'Performer',
      date_of_creation: 'Date of creation',
      start_finish_date: 'Start & Finish Date',
      add_result: 'Add result',
      task_type: 'Task type',
      period: 'Period',
      cancel: 'Cancel',
      creator: 'Creator',
      new_status: 'New',
      in_progress_status: 'In Progress',
      rejected_status: 'Rejected',
      completed_status: 'Completed',
      modal_title: 'Add a new task',
      by_tasks: 'By tasks',
      by_date: 'By date',
      by_type: 'By type',
      by_manager: 'By the appointed manager',

      for_today: 'for today',
      for_yesterday: 'for yesterday',
      in_the_last_30_days: 'in the last 30 days',
      for_this_week: 'for this week',
      over_the_past_week: 'over the past week',
      for_this_month: 'for this month',
      last_month: 'last month',
      for_the_quarter: 'for the quarter',
      this_year: 'this year',

      color_icons: 'Color icons',
      your_task_type: 'Your task type',
      modal_title_synchronization: 'Synchronization with calendars',
      modal_message_synchronization:
        'With two-way real-time synchronization, you can create tasks and make changes in your Google Calendar and they will be reflected immediately in your CRM, and vice versa',
      button_sync_with_google: 'Sync with Google',

      finish_date: 'Finish date',
    },
  })

  const newAndInProgressTasksCount = React.useMemo(() => {
    return tasks.filter((task) => {
      const statusId = task.status?.id
      return statusId === 1 || statusId === 2
    }).length
  }, [tasks])

  const periods = React.useMemo(
    () => [
      { id: 1, name: translate.for_today },
      { id: 2, name: translate.for_yesterday },
    ],
    [translate.for_today, translate.for_yesterday],
  )

  useEffect(() => {
    setByDate(periods)
  }, [periods])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/crm/tasks') {
        updateFilter({})
      }
    })

    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const handleCheckboxChange = () => {
    setChecked(!checked)
  }

  const onBeforeAddTask = (formData) => {
    const { date, start_at, finish_at } = formData

    const result = {
      ...formData,
      status: 1,
      creator: formData?.assignee,
    }

    const startTime = start_at || '06:00:00'
    const endTime = finish_at || '23:00:00'

    result.start_task = new Date(`${date}T${startTime}`).toISOString()
    result.finish_task = new Date(`${date}T${endTime}`).toISOString()

    delete result.start_at
    delete result.finish_at
    delete result.date

    return [result]
  }

  const onBeforeManagingTaskTypes = async (formData) => {
    return formData
  }

  // Вспомогательная функция: получить Y-M-D по Казахстану для произвольной даты
  const getKzYMD = (date) => {
    // Сдвигаем UTC-время на +5ч и берём UTC-компоненты — это и есть казахстанская дата
    const shifted = new Date(date.getTime() + 5 * 60 * 60 * 1000)
    const yyyy = shifted.getUTCFullYear()
    const mm = String(shifted.getUTCMonth() + 1).padStart(2, '0')
    const dd = String(shifted.getUTCDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  // В fetchTasks: не отправляем период на бэк
  const fetchTasks = () => {
    const currentFilter = filter || {}
    const { status: filterStatus, period_id, ...restFilter } = currentFilter

    const params = { ...restFilter, limit: 2000, offset: 0 }
    params.status = filterStatus?.length ? filterStatus : '1,2'

    superAxiosRequest({
      method: 'get',
      link: 'tasktracker/tasks',
      params,
      crm: true,
    })
      .then((tasksResult) => {
        let result = tasksResult?.data?.result || []

        if (period_id) {
          const todayKz = getKzYMD(new Date())
          const now = new Date()
          const yesterdayKz = getKzYMD(
            new Date(now.getTime() - 24 * 60 * 60 * 1000),
          )

          const target = Number(period_id) === 1 ? todayKz : yesterdayKz
          result = result.filter(
            (t) => t.created_at && getKzYMD(new Date(t.created_at)) === target,
          )
        }

        setTasks(result)
        setFilteredTasks(result)
      })
      .catch(() => {})
  }

  useEffect(() => {
    fetchTasks()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, periods])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'tasktracker/task_categories',
      params: {
        limit: 100,
        offset: 0,
      },
      crm: true,
    })
      .then(({ data }) => {
        setByType(data?.result || [])
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/employees',
      params: { short_form: true },
      crm: true,
    })
      .then(({ data }) => {
        setEmployees(data || [])
      })
      .catch(() => {})
  }, [])

  const menu = [
    { name: translate.export_type, action: 'export' },
    { name: translate.manage_task_types, action: 'task_type' },
    { name: translate.synchronize, action: 'synchronize' },
    {
      name: translate.auto_update,
      action: 'auto_update',
      checkbox: {
        label: translate.auto_update,
        value: checked,
        onChange: handleCheckboxChange,
      },
    },
  ]

  const config = [
    {
      // Фильтр «По дате» — отправляем id периода, который затем
      // в fetchTasks разворачивается в created_at_from / created_at_until
      values: byDate || [],
      nameState: 'period_id',
      placeholder: translate.by_date,
      type: 'select',
      key_name: 'id',
      option_label_key: 'name',
      sort_key: 'name',
      isSearchable: true,
      isSearch: true,
      label: translate.by_date,
    },
    {
      values: byType || [],
      nameState: 'task_category',
      placeholder: translate.by_type,
      type: 'select',
      key_name: 'name',
      option_label_key: 'name',
      sort_key: 'name',
      isSearchable: true,
      isSearch: true,
      convertNum: true,
      label: translate.by_type,
    },
    {
      values: employees || [],
      nameState: 'assignee',
      placeholder: translate.by_manager,
      type: 'select',
      key_name: 'manager',
      option_label_key: 'name',
      sort_key: 'name',
      isSearchable: true,
      isSearch: true,
      convertNum: true,
      label: translate.by_manager,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'tasktracker/task_statuses',
      nameState: 'status',
      label: 'По статусу',
      placeholder: 'По статусу',
    },
    {
      type: 'select',
      apiLinkCRM: 'integration/deal_statuses/?not_id=1',
      nameState: 'deal_status',
      label: 'По воронке',
      placeholder: 'По воронке',
      apiGetResult: (data) => {
        const result = data.result ? data.result : data
        if (!result || !result.length) return []

        const getFunnelName = (funnelId) => {
          if (funnelId === 1) return 'отдел продаж'
          if (funnelId === 8) return 'действующие студенты'
          return `funnel ${funnelId}`
        }

        const sorted = [...result].sort((a, b) => {
          const orderA = a.funnel === 1 ? 1 : a.funnel === 8 ? 2 : 3
          const orderB = b.funnel === 1 ? 1 : b.funnel === 8 ? 2 : 3

          if (orderA !== orderB) return orderA - orderB

          return a.position - b.position
        })

        return sorted.map((status) => ({
          ...status,
          value: status.id,
          label: `${status.name} (${getFunnelName(status.funnel)})`,
        }))
      },
    },
  ]

  const managingTaskTypes = () => {
    const ms = {
      modalBodyComponent: () => <ManagingTaskTypes translate={translate} />,
      button: translate.save,
      crm: true,
      link: 'tasktracker/task_categories',
      title: translate.manage_task_types,
      type: 'managing_task_types',
      onBeforeSubmit: onBeforeManagingTaskTypes,
      onSubmitSuccess: () => {},
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const addNewTask = () => {
    const ms = {
      modalBodyComponent: () => <AddNewTask />,
      crm: true,
      button: translate.save,
      link: 'tasktracker/tasks',
      title: translate.modal_title,
      type: 'add_new_task',
      onBeforeSubmit: onBeforeAddTask,
      onSubmitSuccess: () => fetchTasks(),
      isResponsive: true,
      valid: {
        task_category: 'required',
        assignee: 'required',
        date: 'required',
        deal: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const synchronize = () => {
    const ms = {
      modalBodyComponent: () => (
        <Synchronize link={'#'} translate={translate} />
      ),
      button: translate?.save,
      link: '',
      title: translate?.modal_title_synchronization,
      type: 'synchronize',
      onSubmitSuccess: () => {},
      isResponsive: true,
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const cardAppearance = () => {
    const ms = {
      modalBodyComponent: () => <CardAppearance />,
      button: translate?.save,
      link: '',
      title: 'Card appearance',
      type: 'cardAppearance',
      onSubmitSuccess: () => {},
      isResponsive: true,
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const exportFunc = () => {}

  const action = (action) => {
    switch (action) {
      case 'export':
        exportFunc()
        break
      case 'task_type':
        managingTaskTypes()
        break
      case 'synchronize':
        synchronize()
        break
      case 'card_appearance':
        cardAppearance()
        break
      case 'auto_update':
        break
      default:
        break
    }
  }

  const sortTasksByFinishDate = (tasksToSort) => {
    return [...tasksToSort].sort((a, b) => {
      if (!a.finish_task && !b.finish_task) return 0
      if (!a.finish_task) return 1
      if (!b.finish_task) return -1

      const dateA = new Date(a.finish_task)
      const dateB = new Date(b.finish_task)
      return dateA - dateB
    })
  }

  const getTasksForColumn = (columnType) => {
    const now = new Date()
    const todayStart = new Date(now)
    todayStart.setHours(0, 0, 0, 0)
    const todayEnd = new Date(todayStart)
    todayEnd.setHours(23, 59, 59, 999)

    let filteredTasks = tasks.filter((task) => {
      if (!task.finish_task) return false

      const finishDate = new Date(task.finish_task)

      if (columnType === 'overdue') {
        return finishDate < now
      }
      if (finishDate < now) {
        return false
      }

      if (columnType === 'today') {
        return finishDate >= todayStart && finishDate <= todayEnd
      }

      if (columnType === 'tomorrow') {
        const tomorrowStart = new Date(todayStart)
        tomorrowStart.setDate(todayStart.getDate() + 1)
        const tomorrowEnd = new Date(tomorrowStart)
        tomorrowEnd.setHours(23, 59, 59, 999)
        return finishDate >= tomorrowStart && finishDate <= tomorrowEnd
      }

      const weekStart = new Date(todayStart)
      weekStart.setDate(
        todayStart.getDate() -
          todayStart.getDay() +
          (todayStart.getDay() === 0 ? -6 : 1),
      )
      const weekEnd = new Date(weekStart)
      weekEnd.setDate(weekStart.getDate() + 6)
      weekEnd.setHours(23, 59, 59, 999)

      if (columnType === 'this_week') {
        const isNotToday = !(finishDate >= todayStart && finishDate <= todayEnd)
        const isNotTomorrow = !(
          finishDate >= new Date(todayStart.getTime() + 86400000) &&
          finishDate <= new Date(todayEnd.getTime() + 86400000)
        )
        return (
          finishDate >= weekStart &&
          finishDate <= weekEnd &&
          isNotToday &&
          isNotTomorrow
        )
      }

      if (columnType === 'next_week') {
        const nextWeekStart = new Date(weekStart)
        nextWeekStart.setDate(weekStart.getDate() + 7)
        const nextWeekEnd = new Date(nextWeekStart)
        nextWeekEnd.setDate(nextWeekStart.getDate() + 6)
        nextWeekEnd.setHours(23, 59, 59, 999)
        return finishDate >= nextWeekStart && finishDate <= nextWeekEnd
      }

      if (columnType === 'month_plus') {
        const nextWeekEnd = new Date(weekStart)
        nextWeekEnd.setDate(weekStart.getDate() + 13)
        nextWeekEnd.setHours(23, 59, 59, 999)
        return finishDate > nextWeekEnd
      }

      return false
    })

    return sortTasksByFinishDate(filteredTasks)
  }

  const handleDragEnd = (result) => {
    const { source, destination, draggableId } = result

    if (!destination) {
      return
    }

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return
    }

    const destColumn = TASK_COLUMNS.find(
      (col) => col.id === parseInt(destination.droppableId),
    )
    const destColumnType = destColumn?.type

    if (destColumnType === 'overdue') {
      swal({
        title: 'Внимание!',
        text: 'Нельзя перемещать задачи в колонку "Просроченные задачи"',
        icon: 'warning',
        timer: 2000,
      })
      return
    }

    const movedTask = tasks.find((task) => task.id === parseInt(draggableId))
    if (!movedTask) return

    const newFinishDate = getNewFinishDateByColumnType(destColumnType)

    if (!newFinishDate) {
      swal({
        title: 'Ошибка!',
        text: 'Не удалось определить дату для целевой колонки',
        icon: 'error',
        timer: 2000,
      })
      return
    }

    const newTasksData = Array.from(tasks)
    const updatedTask = {
      ...movedTask,
      finish_task: newFinishDate,
    }

    const taskIndex = newTasksData.findIndex((t) => t.id === movedTask.id)
    if (taskIndex !== -1) {
      newTasksData[taskIndex] = updatedTask
      setTasks(newTasksData)
    }

    superAxiosRequest(
      {
        link: `tasktracker/tasks/${draggableId}`,
        method: 'put',
        crm: true,
      },
      {
        assignee: movedTask.assignee?.id || movedTask.assignee,
        creator: movedTask.creator?.id || movedTask.creator,
        deal: movedTask.deal?.id || movedTask.deal,
        finish_task: newFinishDate,
        start_task: movedTask.start_task,
        status: movedTask.status?.id || movedTask.status,
        task_category: movedTask.task_category?.id || movedTask.task_category,
      },
    )
      .then(() => {
        fetchTasks()
        swal({
          title: 'Успех!',
          text: `Задача перемещена. Новая дата: ${new Date(
            newFinishDate,
          ).toLocaleDateString()}`,
          icon: 'success',
          timer: 1500,
        })
      })
      .catch((error) => {
        fetchTasks()
        console.error('Error moving task:', error)
        swal({
          title: 'Ошибка!',
          text: 'Не удалось переместить задачу',
          icon: 'error',
          timer: 2000,
        })
      })
  }

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/crm/tasks') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const containerRef = useRef(null)

  return (
    <div className={styles.container}>
      <div className={styles.taskHeader}>
        <PageHeader title={translate.page_title}>
          <div className={styles.btnsContainer}>
            <div className={styles.dealCountWrapper}>
              <span className={styles.dealCountLabel}>Задач:</span>
              <span className={styles.dealCountValue}>
                {newAndInProgressTasksCount}
              </span>
            </div>
            <div className={styles.verticalSeparator}></div>
            <ActionMenu menu={menu} action={action} />
            <div className={styles.verticalSeparator}></div>
            <HeaderAddButton title={translate.add_task} onClick={addNewTask} />
          </div>
        </PageHeader>
        <div className={styles.search}>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, search: text })
              changeTextValue('search', {
                key: 'search',
                label: 'Search by tasks',
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            value={filter?.search || ''}
            placeholder={translate?.search + '...'}
            translate={translate}
          />
          {!!filterTextValues.length && (
            <FilterTextValues
              onDelete={(key) => {
                const { [key]: _, ...obj } = filter
                updateFilter(obj)
              }}
            />
          )}
          {isOpenFilter && (
            <AsideFilter
              getFilterParams={(e) => {
                updateFilter(e)
              }}
              config={config}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                closeFilter()
              }}
              translate={translate}
            />
          )}
        </div>
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className={styles.cardsColumnsContainer} ref={containerRef}>
          <div className={styles.cardsColumns}>
            {TASK_COLUMNS.map((column) => (
              <Droppable
                key={column.id}
                droppableId={column.id.toString()}
                isDropDisabled={column.type === 'overdue'}
              >
                {(provided, snapshot) => (
                  <div
                    className={styles.cardsColumn}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      opacity:
                        snapshot.isDraggingOver && column.type === 'overdue'
                          ? 0.5
                          : 1,
                    }}
                  >
                    <div className={styles.columnHeader}>
                      <div className={styles.columnName}>{column.name}</div>
                      <div className={styles.countTask}>
                        {getTasksForColumn(column.type).length}{' '}
                        {translate.cards}
                      </div>
                    </div>
                    {getTasksForColumn(column.type).map((task, index) => (
                      <Draggable
                        key={task.id}
                        draggableId={task.id.toString()}
                        index={index}
                        isDragDisabled={column.type === 'overdue'}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <TaskCard
                              translate={translate}
                              {...task}
                              taskCategories={byType}
                              allTasks={tasks}
                              setAllTasks={setTasks}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            ))}
          </div>
        </div>
      </DragDropContext>
      <CustomScrollbar containerRef={containerRef} />
    </div>
  )
}

export default observer(TasksBoard)
